import {
  LOAD_SUCCESS_CODES_COULEURS,
  LOAD_FAIL_CODES_COULEURS,
  SAVE_SUCCESS_CODES_COULEURS,
  SAVE_FAIL_CODES_COULEURS,
  UPDATE_SUCCESS_CODES_COULEURS,
  UPDATE_FAIL_CODES_COULEURS,
  DELETE_SUCCESS_CODES_COULEURS,
  DELETE_FAIL_CODES_COULEURS,
} from "../actions/codeCouleurAction";

const initialState = {
  loaded: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_SUCCESS_CODES_COULEURS:
      return {
        ...state,
        loaded: true,
        data: action.payload,
        error: null,
      };
    case LOAD_FAIL_CODES_COULEURS:
      return {
        ...state,
        loaded: false,
        data: null,
        error: action.error,
      };
    case SAVE_SUCCESS_CODES_COULEURS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: [...state.data, action.payload],
        error: null,
      };
    case SAVE_FAIL_CODES_COULEURS:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case UPDATE_SUCCESS_CODES_COULEURS:
      const updatedListe = [];

      state.data.forEach((item) => {
        if (item.code_couleur_id === action.payload.code_couleur_id) {
          item = action.payload;
        }
        updatedListe.push(item);
      });

      return {
        ...state,
        loading: false,
        loaded: true,
        data: updatedListe,
        error: null,
      };
    case UPDATE_FAIL_CODES_COULEURS:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case DELETE_SUCCESS_CODES_COULEURS:
      const filtered = state.data.filter((item) => {
        return item.code_couleur_id !== action.id;
      });
      return {
        ...state,
        loading: false,
        loaded: true,
        data: filtered,
        error: null,
      };
    case DELETE_FAIL_CODES_COULEURS:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    default:
      return state;
  }
}
